/* H26 · comportamentos compartilhados da home 2026. Seções só marcam o HTML; nada de script inline.
   - Carrossel: [data-h26-carousel] com [data-h26-track] + [data-h26-prev]/[data-h26-next]
     (setas em qualquer lugar dentro do carousel; desabilitam nas pontas).
     Opcionais dentro do carousel:
       [data-h26-progress] → recebe --h26-progress (0..1, posição) e --h26-visible (0..1, fração visível)
       [data-h26-dots]     → container com 1 <button> por slide; o ativo ganha aria-current="true"
                             e .is-active; clique leva ao slide.
   - Acordeão: [data-h26-accordion] com [data-h26-acc-item] → [data-h26-acc-head] (de preferência
     <button> dentro do heading) + [data-h26-acc-body]. "single" (padrão) = um aberto por vez;
     "multi" = independentes. data-h26-acc-keep = não fecha o último aberto.
   - Reveal: [data-h26-reveal] e [data-h26-reveal-group] (ver h26-base.css).
   - Pausa: [data-h26-pause] ganha .is-off quando sai da tela (marquees pausam).
   html.h26-js é adicionado aqui: sem JS nada fica escondido. */
(function () {
  var doc = document.documentElement;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SB = RM ? 'auto' : 'smooth';

  /* seção (o box dela existe mesmo com o conteúdo pulado por content-visibility) começa abaixo de 1,5 tela? */
  function farBelow(el) {
    var sec = el.closest('[data-h26]') || el;
    return sec.getBoundingClientRect().top > window.innerHeight * 1.5;
  }

  /* ---------------- Carrossel ---------------- */
  function initCarousel(root) {
    if (root.__h26) return; root.__h26 = true;
    var track = root.querySelector('[data-h26-track]');
    if (!track) return;
    var prevs = root.querySelectorAll('[data-h26-prev]');
    var nexts = root.querySelectorAll('[data-h26-next]');
    var progress = root.querySelector('[data-h26-progress]');
    var dots = root.querySelector('[data-h26-dots]');
    var dotBtns = dots ? dots.querySelectorAll('button') : [];

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function activeIndex() {
      // slide cuja borda esquerda está mais perto do início da área visível
      var left = track.getBoundingClientRect().left, best = 0, dist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var d = Math.abs(track.children[i].getBoundingClientRect().left - left);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      // a sangria à direita (padding-right) cria rolagem "pro vazio": a seta "próximo" desliga
      // quando o último card já está inteiro na tela, mesmo sobrando padding pra rolar
      var pad = parseFloat(getComputedStyle(track).paddingRight) || 0;
      var limit = max - pad - 2;
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      nexts.forEach(function (b) { b.disabled = limit <= 0 || track.scrollLeft >= limit; });
      // tudo cabe na tela (nada pra rolar): esconde as setas — CSS usa visibility, então o espaço fica e
      // nada pula quando a largura muda e elas voltam
      root.classList.toggle('is-static', limit <= 0);
      if (progress) {
        progress.style.setProperty('--h26-progress', max > 0 ? Math.min(1, track.scrollLeft / max) : 0);
        progress.style.setProperty('--h26-visible', track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1);
      }
      if (dotBtns.length) {
        var a = activeIndex();
        dotBtns.forEach(function (d, i) {
          d.classList.toggle('is-active', i === a);
          if (i === a) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
    }
    function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

    prevs.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: SB }); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: SB }); }); });
    dotBtns.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var s = track.children[i]; if (!s) return;
        track.scrollTo({ left: s.offsetLeft - track.children[0].offsetLeft, behavior: SB });
      });
    });
    // medir (scrollWidth, getBoundingClientRect) só quando o carrossel chega perto da tela: as seções
    // abaixo da dobra usam content-visibility:auto e medir antes forçaria renderizar a seção inteira
    function start() {
      track.addEventListener('scroll', schedule, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
      else window.addEventListener('resize', schedule);
      update();
    }
    if (farBelow(root) && 'IntersectionObserver' in window) {
      var nio = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { nio.disconnect(); start(); }
      }, { rootMargin: '100% 0px' });
      nio.observe(root);
    } else start();
  }

  /* ---------------- Acordeão ---------------- */
  var accSeq = 0;
  function initAccordion(root) {
    if (root.__h26) return; root.__h26 = true;
    var single = root.getAttribute('data-h26-accordion') !== 'multi';
    var keep = root.hasAttribute('data-h26-acc-keep');
    root.querySelectorAll('[data-h26-acc-item]').forEach(function (item) {
      var head = item.querySelector('[data-h26-acc-head]');
      var body = item.querySelector('[data-h26-acc-body]');
      if (!head || !body) return;
      // embrulha o conteúdo pro grid 0fr→1fr animar
      if (!body.querySelector(':scope > [data-h26-acc-inner]')) {
        var inner = document.createElement('div');
        inner.setAttribute('data-h26-acc-inner', '');
        while (body.firstChild) inner.appendChild(body.firstChild);
        body.appendChild(inner);
      }
      if (!body.id) body.id = 'h26-acc-' + (++accSeq);
      if (head.tagName !== 'BUTTON') { head.setAttribute('role', 'button'); head.setAttribute('tabindex', '0'); }
      head.setAttribute('aria-controls', body.id);
      head.setAttribute('aria-expanded', String(item.classList.contains('is-open')));

      function setOpen(it, open) {
        it.classList.toggle('is-open', open);
        var h = it.querySelector('[data-h26-acc-head]'); if (h) h.setAttribute('aria-expanded', String(open));
      }
      function toggle() {
        var open = item.classList.contains('is-open');
        if (open && keep) return;
        if (single) root.querySelectorAll('[data-h26-acc-item].is-open').forEach(function (o) { if (o !== item) setOpen(o, false); });
        setOpen(item, !open);
      }
      head.addEventListener('click', toggle);
      if (head.tagName !== 'BUTTON') {
        head.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      }
    });
  }

  /* ---------------- Reveal + pausa (um IntersectionObserver só) ---------------- */
  var hasIO = 'IntersectionObserver' in window;
  // reveal: dispara um pouco depois de entrar (-10% embaixo) pra animação ser vista
  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 }) : null;
  // pausa de marquee: qualquer pixel na tela = rodando (sem margem negativa)
  var pauseIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
  }, { rootMargin: '0px', threshold: 0 }) : null;

  function show(el) {
    el.__h26in = true;
    if (el.hasAttribute('data-h26-reveal-group')) {
      var n = 0, vw = window.innerWidth;
      el.querySelectorAll('[data-h26-reveal]').forEach(function (c) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--h26-i', r.left < vw ? Math.min(n++, 5) : 0);
        c.classList.add('is-in');
      });
    }
    el.classList.add('is-in');
  }
  function initReveal(scope) {
    if (!io) return;
    var els = (scope || document).querySelectorAll('[data-h26-reveal-group], [data-h26-reveal]');
    els.forEach(function (el) {
      if (el.__h26in) return;
      // filho de grupo é revelado pelo grupo
      if (!el.hasAttribute('data-h26-reveal-group') && el.parentElement && el.parentElement.closest('[data-h26-reveal-group]')) return;
      // o que já está na tela ao carregar aparece sem animar (nunca pisca)
      // mede pela seção primeiro: medir o elemento numa seção pulada (content-visibility) forçaria o layout dela
      var sec = el.closest('[data-h26]') || el, vh = window.innerHeight;
      if (sec.getBoundingClientRect().top < vh && el.getBoundingClientRect().top < vh) { el.classList.add('is-in'); el.querySelectorAll('[data-h26-reveal]').forEach(function (c) { c.classList.add('is-in'); }); el.__h26in = true; return; }
      io.observe(el);
    });
    (scope || document).querySelectorAll('[data-h26-pause]').forEach(function (el) { if (!el.__h26p) { el.__h26p = true; pauseIO.observe(el); } });
  }

  /* ---------------- Repasse de parâmetros pro oferta ----------------
     CTA da home vai pra outro domínio (oferta.liquidz.com.br): sem repasse, utm_* e o cupom de CRM
     (?discount=&pct=) morrem na travessia. Copia os parâmetros da visita pros links do oferta,
     sem sobrescrever o que o link já traz; ignora os de preview/editor da Shopify. */
  var SKIP = /^(preview_theme_id|view|pb|_|_ab|_fd|_sc|section_id|oseid|key)$/;
  function passParams(scope) {
    var q = new URLSearchParams(window.location.search), keep = [];
    q.forEach(function (v, k) { if (!SKIP.test(k)) keep.push([k, v]); });
    if (!keep.length) return;
    (scope || document).querySelectorAll('[data-h26] a[href*="oferta.liquidz.com.br"]').forEach(function (a) {
      if (a.__h26q) return; a.__h26q = true;
      try {
        var u = new URL(a.href);
        keep.forEach(function (p) { if (!u.searchParams.has(p[0])) u.searchParams.set(p[0], p[1]); });
        a.href = u.toString();
      } catch (e) {}
    });
  }

  function init(scope) {
    passParams(scope);
    (scope || document).querySelectorAll('[data-h26-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-h26-accordion]').forEach(initAccordion);
    initReveal(scope);
  }

  // marca ANTES do primeiro paint possível pra o reveal não piscar; o conteúdo da 1ª dobra
  // é marcado .is-in no init (síncrono no DOMContentLoaded, antes do primeiro frame com estilos).
  doc.classList.add('h26-js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // theme editor: re-inicializa a seção recarregada
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.H26 = { init: init };
})();

/* H26 · Link da bio do Instagram — a bio aponta pra home com ?utm_source=ig&utm_medium=social&utm_content=link_in_bio.
   Dispara o ll_bio_view (o mesmo do bio.liquidz.com.br) pra o card da bio na daily seguir contando: lá a coorte é
   por 1ª ll_bio_view SEM filtro de pageName, então pageName "HOME" só separa a origem, não quebra a série.
   Identidade: o $device do mp___LL_SUITE_mixpanel (.liquidz.com.br, gravado pelo pixel do LL Suite ~1s após o load)
   — é o mesmo distinct_id que o oferta.* usa, então LP/carrinho/compra caem no perfil da bio. Espera até 3s por ele;
   sem cookie, cai no lb_did (mesmo fallback do cart-drawer-tracking.js) e a coorte fica sem a costura. */
(function () {
  try {
    var q = new URLSearchParams(location.search);
    if ((q.get('utm_content') || '').toLowerCase() !== 'link_in_bio') return;
    if ((q.get('utm_source') || '').toLowerCase() !== 'ig') return;
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) { return; }

  function rid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  function suiteId() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)mp___LL_SUITE_mixpanel=([^;]*)/);
      var o = m && JSON.parse(decodeURIComponent(m[1]));
      return (o && o.distinct_id) || '';
    } catch (e) { return ''; }
  }
  function fallbackId() {
    if (window.__LB_DISTINCT_ID__) return window.__LB_DISTINCT_ID__;
    try {
      var v = localStorage.getItem('lb_did');
      if (!v) { v = 'anon_' + rid(); localStorage.setItem('lb_did', v); }
      return v;
    } catch (e) { return 'anon_' + rid(); }
  }
  function send(id) {
    var props = { pageName: 'HOME', page_url: location.pathname, $insert_id: 'll_bio_view_' + rid() };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) {
      var v = q.get(k); if (v) props[k] = v;
    });
    try {
      fetch('https://api.liquidz.com.br/api/track', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ event: 'll_bio_view', distinct_id: id, properties: props })
      }).catch(function () {});
    } catch (e) {}
  }

  var tries = 0;
  (function wait() {
    var id = suiteId();
    if (id) return send(id);
    if (++tries >= 15) return send(fallbackId());
    setTimeout(wait, 200);
  })();
})();

/* H26 · Vidro líquido — par do bloco "Vidro líquido" do h26-base.css. Técnica de refração portada de liquid-glass-react
   (MIT, © 2025 Max Rovensky). Faz duas coisas, nada por frame de rolagem:
   1. Brilho que segue o mouse (só ponteiro fino): --g-x/--g-y no card sob o cursor, em rAF.
   2. Refração (só Chromium desktop, sem "reduzir movimento/transparência"): liga html.h26-lg-refract e
      monta UM filtro SVG por tamanho de card — mapa de deslocamento das bordas (canvas, uma vez) +
      3 feDisplacementMap com escalas diferentes por canal (aberração cromática) somados em screen.
      Mede o card só quando ele chega perto da tela (as seções usam content-visibility). */
(function () {
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var brands = (navigator.userAgentData && navigator.userAgentData.brands) || [];
  var CHROMIUM = brands.some(function (b) { return /Chromium/.test(b.brand); });
  var REFRACT = CHROMIUM && FINE && !mq('(prefers-reduced-motion: reduce)') && !mq('(prefers-reduced-transparency: reduce)');
  var NS = 'http://www.w3.org/2000/svg';
  var BAND = 26;      // largura (px) da borda que refrata
  var SCALE = 56;     // desvio máximo ≈ SCALE/2 px na beirada
  var ABER = 0.08;    // diferença de escala entre canais (aberração cromática)
  var defs = null, made = {};

  function map(w, h, r, top) {
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'), img = x.createImageData(w, h), d = img.data;
    var hw = w / 2, hh = h / 2;
    for (var py = 0; py < h; py++) for (var px = 0; px < w; px++) {
      // distância até a borda do retângulo arredondado (SDF) e normal pra fora
      var ox = px + .5 - hw, oy = py + .5 - hh, qx = Math.abs(ox) - (hw - r), qy = Math.abs(oy) - (hh - r);
      var mx = Math.max(qx, 0), my = Math.max(qy, 0), out = Math.sqrt(mx * mx + my * my);
      var dist = r - out - Math.min(Math.max(qx, qy), 0);
      var nx, ny;
      if (qx > 0 && qy > 0) { nx = mx / (out || 1); ny = my / (out || 1); } else if (qx > qy) { nx = 1; ny = 0; } else { nx = 0; ny = 1; }
      nx *= ox < 0 ? -1 : 1; ny *= oy < 0 ? -1 : 1;
      // faixa no pé do card: laterais e pé são a borda do card (recortada) → só a beirada de cima refrata
      if (top) { dist = py + .5; nx = 0; ny = -1; }
      var t = Math.min(Math.max(dist / BAND, 0), 1), m = (1 - t) * (1 - t);
      var i = (py * w + px) * 4;
      // amostra PRA DENTRO (normal invertida): a beirada "puxa" o fundo como uma lente, sem buraco transparente
      d[i] = 128 - nx * m * 127; d[i + 1] = 128; d[i + 2] = 128 - ny * m * 127; d[i + 3] = 255;
    }
    x.putImageData(img, 0, 0);
    return c.toDataURL();
  }
  function el(tag, at) { var n = document.createElementNS(NS, tag); for (var k in at) n.setAttribute(k, at[k]); return n; }
  function channel(f, scale, m, name) {
    f.appendChild(el('feDisplacementMap', { in: 'SourceGraphic', in2: 'M', scale: scale, xChannelSelector: 'R', yChannelSelector: 'B', result: name + 'd' }));
    f.appendChild(el('feColorMatrix', { in: name + 'd', type: 'matrix', values: m, result: name }));
  }
  function filterFor(w, h, r, top) {
    var id = 'h26-lg-' + w + '-' + h + '-' + r + (top ? 't' : '');
    if (made[id]) return id;
    if (!defs) {
      var svg = el('svg', { width: 0, height: 0, 'aria-hidden': 'true', focusable: 'false' });
      svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
      defs = el('defs', {}); svg.appendChild(defs); document.body.appendChild(svg);
    }
    var f = el('filter', { id: id, x: 0, y: 0, width: w, height: h, filterUnits: 'userSpaceOnUse', primitiveUnits: 'userSpaceOnUse', 'color-interpolation-filters': 'sRGB' });
    f.appendChild(el('feImage', { href: map(w, h, r, top), x: 0, y: 0, width: w, height: h, preserveAspectRatio: 'none', result: 'M' }));
    channel(f, SCALE, '1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0', 'R');
    channel(f, SCALE * (1 - ABER), '0 0 0 0 0  0 1 0 0 0  0 0 0 0 0  0 0 0 1 0', 'G');
    channel(f, SCALE * (1 - 2 * ABER), '0 0 0 0 0  0 0 0 0 0  0 0 1 0 0  0 0 0 1 0', 'B');
    f.appendChild(el('feBlend', { in: 'G', in2: 'B', mode: 'screen', result: 'GB' }));
    f.appendChild(el('feBlend', { in: 'R', in2: 'GB', mode: 'screen' }));
    defs.appendChild(f); made[id] = 1;
    return id;
  }
  function fit(g) {
    var b = g.getBoundingClientRect(); if (!b.width || !b.height) return;
    var bw = parseFloat(getComputedStyle(g).getPropertyValue('--g-bw')) || 0;
    var w = Math.round(b.width + 2 * bw), h = Math.round(b.height + 2 * bw);
    var r = Math.min(Math.round(parseFloat(getComputedStyle(g).borderTopLeftRadius) || 0), Math.floor(Math.min(w, h) / 2));
    var top = g.classList.contains('h26-glass--band');
    var key = w + 'x' + h + 'x' + r + top; if (g.__h26lg === key) return; g.__h26lg = key;
    g.style.setProperty('--g-filter', 'url(#' + filterFor(w, h, r, top) + ')');
  }

  function init(scope) {
    var gs = (scope || document).querySelectorAll('.h26-glass');
    if (!gs.length) return;
    if (REFRACT) {
      document.documentElement.classList.add('h26-lg-refract');
      var ro = 'ResizeObserver' in window ? new ResizeObserver(function (es) { es.forEach(function (e) { fit(e.target); }); }) : null;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fit(e.target); if (ro) ro.observe(e.target); } });
      }, { rootMargin: '100% 0px' });
      gs.forEach(function (g) { if (!g.__h26lgo) { g.__h26lgo = 1; io.observe(g); } });
    }
  }

  // brilho que segue o mouse: só lê a caixa do card sob o cursor, escreve 2 variáveis por frame
  if (FINE) {
    var cur = null, ex = 0, ey = 0, raf = 0;
    document.addEventListener('pointermove', function (e) {
      var g = e.target.closest && e.target.closest('.h26-glass');
      if (g !== cur) { if (cur) { cur.style.removeProperty('--g-x'); cur.style.removeProperty('--g-y'); } cur = g; }
      if (!g) return;
      ex = e.clientX; ey = e.clientY;
      if (!raf) raf = requestAnimationFrame(function () {
        raf = 0; if (!cur) return;
        var b = cur.getBoundingClientRect();
        cur.style.setProperty('--g-x', ((ex - b.left) / b.width * 100).toFixed(1) + '%');
        cur.style.setProperty('--g-y', ((ey - b.top) / b.height * 100).toFixed(1) + '%');
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
